module.exports = __webpack_public_path__ + "img/brand--axteroid.7e2aa76f.svg";